<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.alergias"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:cell(info)="row">
                <div v-if="row.item.centroCusto">
                    <rkm-icon
                        :id="uniqueId(`pronto-atendimento-alergia-info-${row.index}`)"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="uniqueId(`pronto-atendimento-alergia-info-${row.index}`)"
                        triggers="hover"
                    >
                        <div>{{ row.item.centroCusto.setor.nome }}</div>
                        <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                        <div><rkm-icon :icon="['far', 'clock']" /> {{ row.item.dataHora }}</div>
                    </rkm-popover>

                    {{ row.item.dataHora }}
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$refs.Modal.open(row)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(row)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    computed: {
        fields() {

            const fields = []

            if (!this.hideInfo) {

                fields.push({ key: 'info', label: 'Data / Hora', class: 'col-min' })
            }

            fields.push({ key: 'alergia.tipo.descricao', label: 'Tipo' })
            fields.push({ key: 'alergia.agenteSubstanciaEspecifica', label: 'Agente / Substância específica' })
            fields.push({ key: 'alergia.criticidade.nome', label: 'Criticidade' })
            fields.push({ key: 'alergia.reacoesObservacoes', label: 'Reações / Observações' })
            fields.push({ key: 'alergia.cid.codigoNome', label: 'CID' })

            if (!this.readonly) {
                fields.push({ key: 'actions', label: 'Ações', class: "col-min" })
            }

            return fields
        }
    },
    methods: {
        handleDestroy(row) {
            const destroy = () => new Promise(resolve => {
                resolve(this.data.model.alergias.splice(row.index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
        hideInfo: { type: Boolean, default: false },
        readonly: { type: Boolean, required: true },
    },
}
</script>